import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimecustomModule } from 'src/app/shared/primeng.custom.module';

@Component({
  selector: 'app-consent',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, PrimecustomModule],
  templateUrl: './consent.component.html',
  styleUrl: './consent.component.scss',
})
export class ConsentComponent {
  @Input() consentData: any;
  contentTemplate: any;
  ngOnInit() {
    this.contentTemplate = this.consentData?.consentTemplate;
  }
}
